import { JSX, useState, useEffect } from 'react'

import { Box, Flex, HStack, Center } from '@chakra-ui/react'
// eslint-disable-next-line no-duplicate-imports
import { SegmentGroup, Icon, Avatar, Text } from '@chakra-ui/react'


import { RxBell } from 'react-icons/rx'

import { Throttle } from '@/lib/alchemy.js'

import * as mine_storage from '@/storage/mine.js'





// eslint-disable-next-line @typescript-eslint/naming-convention
export function Panel
(props: { children?: JSX.Element }): JSX.Element
{
	return (
		<Center w="full" maxW="breakpoint-lg">{props.children}</Center>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Segment
(
	props: {
		options: string[]

		change?(value: string): void

	},

)
:	JSX.Element
{
	let [default_] = props.options

	let checked_style = {
		color     : 'fg.inverted',
		// eslint-disable-next-line @typescript-eslint/naming-convention
		fontWeight: 'medium',

	}

	let on_change = (value: string): void =>
	{
		props.change?.(value)

	}

	return (
		<Panel>
			<SegmentGroup.Root
				p="1"
				size="sm"
				rounded="4xl"
				defaultValue={default_}
				// eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
				onValueChange={vv => on_change(vv.value!)}
			>
				<SegmentGroup.Indicator bg="blue.solid" rounded="4xl" />

				<SegmentGroup.Items cursor="pointer" items={props.options} _checked={checked_style} />

			</SegmentGroup.Root>

		</Panel>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Notify (): JSX.Element
{
	return (
		<Icon size="md">
			<RxBell />
		</Icon>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function User (): JSX.Element
{
	let [value, dispatch] = useState(
		{
			nickname: 'loading...',
			avatar  : 'https://avatars.githubusercontent.com/u/15063413?v=4',

		},

	)


	useEffect(
		Throttle.once(
			async () =>
			{
				dispatch(await mine_storage.retrieve() )

			},

			{ void: true },


		),


		[],


	)


	return (
		<HStack>
			<Avatar.Root size="2xs">
				<Avatar.Fallback />
				<Avatar.Image src={value.avatar} />
			</Avatar.Root>

			<Text fontSize="sm" fontWeight="bold" whiteSpace="nowrap">{value.nickname}</Text>

		</HStack>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Root
(
	props: {
		breadcrumb: JSX.Element
		children? : JSX.Element

	},

)
:	JSX.Element
{
	return (
		<Box pl="4" pr="4" as="header">
			<Flex
				h="12"
				pl="4"
				pr="4"
				gap="4"
				bg="white"
				shadow="sm"
				borderBottomLeftRadius="md"
				borderBottomRightRadius="md"
				justifyContent="space-between"
				alignItems="center"
			>
				<Box w="72">{props.breadcrumb}</Box>

				{props.children}

				<HStack gap="4" flex="auto" justify="flex-end">
					<Notify />

					<User />
				</HStack>

			</Flex>

		</Box>

	)

}
